import Swiper, {
  Navigation, Lazy,
} from 'swiper';
import BaseComponent from 'scripts/BaseComponent.js';

export default class SubCollectionMenu extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      swiperContainer: '.js-carousel',
      prevArrow: '.js-carouselPrev',
      nextArrow: '.js-carouselNext',
    };

    this.dom = {
      $component: component,
      $swiperContainer: this.$get(this.refs.swiperContainer),
      $prevArrow: this.$getAll(this.refs.prevArrow),
      $nextArrow: this.$getAll(this.refs.nextArrow),
    };

    this.state = {};

    this.mount();
    this.init();
  }

  mount() {
    super.mount();
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    const { dom, state } = this;

    state.swiper = new Swiper(dom.$swiperContainer, {
      modules: [Navigation, Lazy],
      slidesPerView: 'auto',
      spaceBetween: 15,
      centeredSlides: true,
      preloadImages: true,
      lazy: {
        loadOnTransitionStart: true,
      },
      navigation: {
        nextEl: dom.$nextArrow,
        prevEl: dom.$prevArrow,
      },
      breakpoints: {
        768: {
          centeredSlides: false,
        },
        1024: {
          allowTouchMove: false,
          spaceBetween: 0,
        },
      },
    });
  }
}
